import { useEffect, useState, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { includes, get } from 'lodash';
import * as authSelectors from 'modules/auth/selectors';
// import loadScript from 'utils/loadScript';
import { getIpCountryCode } from 'modules/geolocation/selectors';

import {
  POLICY_COOKIE_NAME,
  COUNTRY_CODES_FOR_COOKIES,
  FC_FRAME_BOTTOM_CLASS,
} from '../../constants';
import './styles.css';

const loadScript = (src, attributes = []) =>
  new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      return resolve(true);
    }
    const script = document.createElement('script');
    script.src = src;
    attributes.forEach(([key, value]) => {
      script.setAttribute(key, value);
    });
    script.onload = () => resolve(script);
    script.onerror = () => reject(new Error(`Script load error: ${src}`));
    document.body.appendChild(script);
  });

const FreeChat = ({ license }) => {
  const user = useSelector(authSelectors.getUser);
  const isClientRole = useSelector(authSelectors.getIsClientRole);
  const ipCountryCode = useSelector(getIpCountryCode);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const wasInitialized = useRef(false);

  const showBanner = useMemo(
    () =>
      includes(COUNTRY_CODES_FOR_COOKIES, ipCountryCode) &&
      Cookies.get(POLICY_COOKIE_NAME) !== 'true',
    [ipCountryCode],
  );

  useEffect(() => {
    loadScript('https://fusionmarkets.freshchat.com/js/widget.js')
      .then(() => setScriptLoaded(true))
      .catch((err) => console.error('Freshchat script load error:', err));
  }, []);

  useEffect(() => {
    if (
      !scriptLoaded ||
      !user?.email ||
      !isClientRole ||
      typeof window === 'undefined' ||
      self !== top ||
      !window.fcWidget ||
      window.fcWidget?.isInitialized?.()
    ) {
      return;
    }

    try {
      window.fcWidget.init({
        token: license,
        host: 'https://fusionmarkets.freshchat.com',
        tags: ['public', 'global'],
        widgetUuid: '4f0b37ed-85f8-4d0b-9aae-a5c27c8cb9f2',
        externalId: user._id,
        email: user.email,
        firstName: get(user, 'profile.firstName'),
        lastName: get(user, 'profile.lastName'),
        config: {
          cssNames: {
            widget: `custom_fc_frame ${showBanner ? FC_FRAME_BOTTOM_CLASS : ''}`,
            expanded: 'custom_fc_expanded',
          },
          headerProperty: {
            appName: 'Global Prime',
          },
        },
      });
      wasInitialized.current = true;
    } catch (e) {
      console.error('Freshchat init error:', e);
    }

    return () => {
      try {
        if (wasInitialized.current && window.fcWidget?.destroy) {
          window.fcWidget.destroy();
          wasInitialized.current = false;
        }
      } catch (e) {
        console.error('Freshchat destroy error:', e);
      }
    };
  }, [user, license, isClientRole, scriptLoaded, showBanner]);

  return null;
};

export default FreeChat;
